import anime from 'animejs'

export default class AnimateCustom {
    constructor() {
        this.elements = document.querySelectorAll('[data-animate]')

        if( IntersectionObserver && window.innerWidth > 800 ){
            this.intersectionObserver()
        }else{
            this.resetAnimate(this.elements)

            this.elements.forEach( element =>{
                this.resetAnimate( element.querySelectorAll('[data-animate-child]') )
            })
        }
    }


    init(targets, delay){
        const setDelay = delay ? delay : anime.stagger(150, {start: 0})

        anime({
            targets: targets,
            delay: setDelay,
            opacity: [
                {value: '1', easing: 'easeOutQuint', duration: '2000'}
            ],
            translateY: [
                {value: ['55px', '0'], easing: 'easeOutCirc', duration: '1500'}
            ]
        })
    }


    intersectionObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        }

        this.observer = new IntersectionObserver( (entries)=>{
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const item = entry.target
                    this.init(this.getTargets(item), this.getDelay(item))
                    this.observer.unobserve( entry.target )
                }
            })
        }, options)

        this.elements.forEach(target => {
            this.observer.observe(target);
        })
    }


    /* Utils */

    getDelay(item){
        return item.getAttribute('data-animate-delay')
    }

    getChild(item){
        return item.querySelectorAll('[data-animate-child]')
    }

    getTargets(item){
        return [item, this.getChild(item)]
    }

    resetAnimate(items){
        items.forEach(item =>{
            item.style.opacity="1"
        })
    }
}
